import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeMembership} from "./doppe-action-type-membership";

export const doppeActionTypeMembershipViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeMembership, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeMembershipWidget: (await import('./doppe-action-type-membership-widget/doppe-action-type-membership-widget')).DoppeActionTypeMembershipWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeMembershipWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeMembershipWidget
                {...renderProps}
            />
        );
    },

    activateCTA: actionContext => {
        actionContext.navigateToUrl(actionContext.action.settings.membershipPageLink, true);
    }
})